module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_1_1.24b9a27e.png";